module.exports = __webpack_public_path__ + "assets/img/5.e3bd497a.png";